import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export class HighlightEffect {
    constructor(el) {
        if (!el || !(el instanceof HTMLElement)) {
            return;
        }

        this.highlightedElement = el;
        this.selectMarker = this.highlightedElement.querySelector('.hx__select');
        this.textWrapper = this.highlightedElement.querySelector('.char-split');

        this.animationDefaults = {
            duration: 0.5,
            ease: 'power2.out',
        };

        this.initializeEffect();
    }

    initializeEffect() {
        // Hardware acceleration hints to prevent stutter
        if (this.selectMarker) {
            gsap.set(this.selectMarker, {
                force3D: true,
                willChange: 'width, opacity'
            });
        }
        if (this.textWrapper) {
            gsap.set(this.textWrapper, {
                force3D: true,
                willChange: 'color'
            });
        }

        this.scroll();
    }

    scroll() {
        ScrollTrigger.create({
            trigger: this.highlightedElement,
            start: 'top bottom-=10%',
            onEnter: () => this.animate(),
            onEnterBack: () => this.animate(),
            onLeave: () => this.reset(),
            onLeaveBack: () => this.reset()
        });
    }

    animate() {
        // 1. Highlight Box Expand
        if (this.selectMarker) {
            gsap.to(this.selectMarker, {
                duration: 0.6,
                ease: this.animationDefaults.ease,
                width: 'calc(100% + 10px)',
                left: '-5px',
                opacity: 1,
                overwrite: 'auto'
            });
        }

        // 2. Text Color Change (Whole text block instead of split chars)
        if (this.textWrapper) {
            const targetColor = this.highlightedElement.dataset.highlightTextColor || '#FFFFFF';
            gsap.to(this.textWrapper, {
                color: targetColor,
                duration: 0.4,
                delay: 0.1,
                ease: 'power1.out',
                overwrite: 'auto'
            });
        }
    }

    reset() {
        // Reset Marker
        if (this.selectMarker) {
            gsap.to(this.selectMarker, {
                width: '0%',
                opacity: 0,
                duration: 0.3,
                overwrite: 'auto'
            });
        }

        // Reset Text
        if (this.textWrapper) {
            gsap.to(this.textWrapper, {
                color: 'inherit',
                duration: 0.3,
                overwrite: 'auto'
            });
        }
    }
}
